import { render, staticRenderFns } from "./SubCategoryFilterBadge.vue?vue&type=template&id=5593b07e&"
import script from "./SubCategoryFilterBadge.vue?vue&type=script&lang=js&"
export * from "./SubCategoryFilterBadge.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryFilterBadge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports